import { defineMessage } from 'react-intl'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const lincoln: GetCustomerCopyFunc = () => {
  return {
    workLifeServicesFeaturedDescription: defineMessage({
      defaultMessage: 'Professional resources to help you address personal needs in your daily life',
      description: 'Description for featured work-life services benefit for Lincoln customer',
    }),
  }
}
